import { render, staticRenderFns } from "./listOne.vue?vue&type=template&id=980cc74c&scoped=true&"
import script from "./listOne.vue?vue&type=script&lang=js&"
export * from "./listOne.vue?vue&type=script&lang=js&"
import style0 from "./listOne.vue?vue&type=style&index=0&id=980cc74c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "980cc74c",
  null
  
)

export default component.exports